import { Button, Space, Typography, InputNumber, Switch, message, Row, DatePicker } from "antd";
import React, { useContext, useEffect, useState } from "react";
import { DownloadOutlined, ReloadOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { downloadXlsx } from "../templatesConverter";
import { get_bank_accounts } from "../../../services";
import { ClassificationsContext } from "../../../contexts/ClassificationsContext";
const { Text } = Typography;

export const useBankAccountReportHook = ({
	token, 
	company, 
	bankAccountReportSelected, 
	setBankAccountReportSelected,
	searchType = "status",
	elementsToSearch = {},
	onSendData = () => {},
}) => {	
	const [dataToProcess, setDataToProcess] = useState([]); // For get the matrix for download the excel.
	const [loading, setLoading] = useState(false);
	const [openReviewInvoice, setOpenReviewInvoice] = useState(false);
	const [isUSDActive, setIsUSDActive] = useState(false);
	const [exchangeRate, setExchangeRate] = useState(7.71);
	const [currentYear, setCurrentYear] = useState(0);
	const [yearToConsult, setYearToConsult] = useState("");	

	const { fetchClassificationForBankTransactions } = useContext(ClassificationsContext);

	const onClose = () => {
		setBankAccountReportSelected(null);
		setLoading(false);
		setDataToProcess([]);
		setCurrentYear(-1);
		setYearToConsult("");		
	};

	useEffect(() => {
		if (bankAccountReportSelected !== null && dataToProcess.length === 0) {
			onDrawerOpen();
		}
	}, [bankAccountReportSelected]);

	const onDrawerOpen = async () => {
		setLoading(true);
		
		const today = new Date();
		const startDate = dayjs(new Date(today.getFullYear(), 0, 1));
		const endDate = dayjs(new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59));

		try {
			// Before of nothing, we should have the classifications if it doens't load yet.
			await fetchClassificationForBankTransactions(company.id);
			
			// And then load the report for the bank account.
			const reportResponse = await get_bank_accounts(token, company.id, searchType, {
				...elementsToSearch,
				startDate: startDate.format("YYYY-MM-DD HH:mm:ss"),
				endDate: endDate.format("YYYY-MM-DD HH:mm:ss"),
			});
	
			if(reportResponse == null){						
				setLoading(false);
				return;
			}
			
			// Can be sended just an array or an object.
			onSendData(reportResponse);
			setCurrentYear(today.getFullYear());
			setYearToConsult(`${today.getFullYear()}`);					
		} catch (err) {
			message.error(err.response.data);
		} finally {
			setLoading(false);
		}		
	};

	const fetchNewReports = async () => {
		if(yearToConsult === ""){
			message.error("Porfavor implementa un año para realizar la consulta");
			return;
		}
		
		if(yearToConsult === `${currentYear}`){
			message.error("Porfavor implementa un año diferente");
			return;
		}
		
		const today = new Date();
		const dateToCheck = dayjs(yearToConsult);
		const todayDayJs = dayjs(new Date(today.getFullYear(), 0, 1));

		if(dateToCheck.year() > todayDayJs.year()){
			message.error("No puedes consultar reportes de años superiores al actual");
			return;
		}
		
		setLoading(true);

		const startDate = dayjs(new Date(dateToCheck.year(), 0, 1));
		const endDate = dayjs(new Date(dateToCheck.year(), 11, 31, 23, 59, 59));
		
		const reportResponse = await get_bank_accounts(token, company.id, searchType, {
			...elementsToSearch,
			startDate: startDate.format("YYYY-MM-DD HH:mm:ss"),
			endDate: endDate.format("YYYY-MM-DD HH:mm:ss"),
		});

		if(reportResponse == null){			
			return;
		}
		
		// Can be sended just an array or an object
		onSendData(reportResponse);
		setCurrentYear(dateToCheck.year());		
		setLoading(false);
	};

	const reloadReplicationData = async () => {
		setLoading(true);
		const response = await get_bank_accounts(token, company.id, "replication", {});
		if (response) {
			if (response.success) {
				await onDrawerOpen();
			} else {
				message.error(response.message);
			}
		} else {
			message.error("Error al recargar los datos de replicación");
		}
		setLoading(false);
	};

	const ExchangeComponent = (
		<Row justify="space-between">
			<Space> 
				<Text>Año Reporte:</Text>
				<DatePicker 
					picker="year"
					value={yearToConsult !== "" ? dayjs(yearToConsult) : null}
					onChange={(_, dateString) => setYearToConsult(dateString)}
				/>
				<Button type="primary" onClick={fetchNewReports}>Consultar</Button>
			</Space>
			<Space>
				<Switch 
					checkedChildren="$" 
					unCheckedChildren="Q"
					checked={isUSDActive}
					onChange={setIsUSDActive}
				/>

				<Text style={{ whiteSpace: "nowrap" }}>Tasa de Cambio: </Text>

				<InputNumber
					prefix={"Q"}
					min={0.01}
					max={100.00}
					precision={2}
					step={0.01}
					value={exchangeRate}
					onChange={setExchangeRate}
					loading={loading}
					controls={false}
				/>		
			</Space>
		</Row>
	);

	const DownloadOptions = (
		<Space>					
			<Space style={{ width: "50%" }}>					
				<Button
					type="primary"
					icon={<DownloadOutlined />}
					loading={loading}
					onClick={() => {				
						if(dataToProcess.length <= 0){
							message.error("No hay data para hacer la descarga");
							return;
						}
												
						const today = dayjs(new Date());
						const nameFile = `_Report_${today.format("YYYY-MM-DD HH:mm:ss")}-Company_${company.name}-${company.tid}-BankAccount_${bankAccountReportSelected.account_number}`;

						if (searchType === "consolidated_report") { // I hate the nested ifs, but they are neccesary							
							let formatedDataMatrix = [...dataToProcess];

							const posibleNestedArray = formatedDataMatrix[formatedDataMatrix.length - 4];

							if (Array.isArray(posibleNestedArray)) {
								const hasNestedArrays = posibleNestedArray.some(item => Array.isArray(item));

								if (hasNestedArrays) {
									const headerAndData = formatedDataMatrix.slice(0, formatedDataMatrix.length - 4);
									const banksAccountsData = posibleNestedArray;
									const footerData = formatedDataMatrix.slice(formatedDataMatrix.length - 3, formatedDataMatrix.length);

									const finalMatrix = [...headerAndData, ...banksAccountsData, ...footerData];
									downloadXlsx(finalMatrix, nameFile, "color");
									return;
								}
							}

							downloadXlsx(formatedDataMatrix, nameFile, "color");
							return;
						}

						downloadXlsx(dataToProcess, nameFile, "color");
					}}
					disabled={dataToProcess.length === 0}
					ghost
				>
					Descargar Reporte Excel
				</Button>

				<Button
					type="primary"
					icon={<DownloadOutlined />}
					loading={loading}
					onClick={() => {
						if(dataToProcess.length <= 0){
							message.error("No hay data para hacer la descarga");
							return;
						}

						setOpenReviewInvoice(true);
					}}
					disabled={dataToProcess.length === 0}
					ghost
				>
					Descargar PDF
				</Button>
				<Button
					type="primary"
					icon={<ReloadOutlined />}
					loading={loading}
					onClick={reloadReplicationData}
					disabled={dataToProcess.length === 0}
				>
					Actualizar Datos
				</Button>
			</Space>
		</Space>
	);
		
	return {		
		dataToProcess,
		loading,
		openReviewInvoice,
		exchangeRate,
		isUSDActive,
		currentYear,		
		ExchangeComponent,
		DownloadOptions,
		setDataToProcess,
		setOpenReviewInvoice,
		onClose,
	};
};